import { createFileRoute } from '@tanstack/react-router'
import DiaryChildren from '@/components/Exercises/DiaryChildren/DiaryChildren'

export const Route = createFileRoute(
  "/(content)/children/exercises/(shared)/diary-children/exercise"
)({
  component: () => <DiaryChildren />,
  head: () => ({
    meta: [
      {
        title: "Writing a Diary - HAMD",
      },
    ],
  }),
  beforeLoad: () => ({
    title: "weakness.exercises.diary",
    navbar: {
      showTitle: true,
    },
  }),
});
